import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-guest-segments',
  templateUrl: './guest-segments.component.html',
  styleUrls: ['./guest-segments.component.scss']
})
export class GuestSegmentsComponent implements OnInit {
  public addonTabs: any;
  @Input('data') data: any;
  public selectedAddonSegment: { value: string; name: string; }; 

  constructor(private modalController: ModalController,private cdr: ChangeDetectorRef) {
   }

  ngOnInit(): void {
    this.addonTabs = this.data?.addonTabs;
    this.selectedAddonSegment = this.data?.selectedAddonSegment;
    this.cdr.detectChanges();
  }
  dismiss(tab) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    if(tab){
    this.modalController.dismiss({
      dismissed: true,
      selectedAddonSegment: tab
    });
  }

  else{
    this.modalController.dismiss({
      dismissed: true,
    });
  }
  }
}
